module.exports = __webpack_public_path__ + "img/ເວບໄຊ-laodl-768x268.5075b3d3.jpg";